import React, { FC } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { CanDisable } from '@modernloop/shared/helper-components';
import { Box, Tooltip } from '@mui/material';

import { CurrentTrainingSessionStatus } from 'src/generated/mloop-graphql';

type Props = {
  children: React.ReactNode;
  currentTrainingSessionStatus?: CurrentTrainingSessionStatus;
};

const PendingApprovalDisableWrapper: FC<Props> = ({ children, currentTrainingSessionStatus }) => {
  const { t } = useTranslation();
  if (currentTrainingSessionStatus === CurrentTrainingSessionStatus.NeedsApproval) {
    return (
      <Tooltip title={t('hiring-dashboard-interviewers:interviewers.pendingApproval.disabledWhilePending')}>
        <Box>
          <CanDisable disabled>{children}</CanDisable>
        </Box>
      </Tooltip>
    );
  }

  return <>{children}</>;
};

export default PendingApprovalDisableWrapper;
